import { Stack } from "@mui/material";
import { styled } from "@mui/material/styles";

const PREFIX = "ActionsDashboardListItemStack";

export const classes = {
  root: `${PREFIX}-root`,
  todo: `${PREFIX}-todo`,
  done: `${PREFIX}-done`,
  missed: `${PREFIX}-missed`,
  late: `${PREFIX}-late`,
  title: `${PREFIX}-title`,
  capitalize: `${PREFIX}-capitalize`,
  uncapitalize: `${PREFIX}-uncapitalize`,
};

export const ActionCardStack = styled(Stack)(({ theme }) => ({
  [`&.${classes.root}`]: {
    position: "relative",
    overflow: "hidden",
    flexDirection: "row",
    alignItems: "center",
    gap: theme.spacing(2),
    justifyContent: "space-between",
    border: `solid 1px ${theme.palette.border.main}`,
    borderRadius: "8px",
    paddingTop: theme.spacing(2),
    paddingBottom: theme.spacing(2),
    paddingLeft: theme.spacing(3),
    paddingRight: theme.spacing(3),
    "&:before": {
      content: "''",
      position: "absolute",
      left: 0,
      top: 0,
      width: "8px",
      height: "100%",
    },
    [`&.${classes.todo}:before`]: {
      backgroundColor: theme.palette.primary.main,
    },
    [`&.${classes.done}:before`]: {
      backgroundColor: theme.palette.success.main,
    },
    [`&.${classes.missed}:before`]: {
      backgroundColor: theme.palette.gray.dark,
    },
    [`&.${classes.late}:before`]: {
      backgroundColor: theme.palette.secondary.dark,
    },
    [`& .${classes.title}`]: {
      flex: "auto",
      display: "flex",
      whiteSpace: "nowrap",
      overflow: "hidden",
      textOverflow: "ellipsis",
      [`& .${classes.capitalize}, & .${classes.uncapitalize}`]: {
        flex: "auto",
        display: "block",
        overflow: "hidden",
        textOverflow: "ellipsis",
      },
      [`& .${classes.capitalize}:first-letter`]: {
        textTransform: "uppercase",
      },
      [`& .${classes.uncapitalize}:first-letter`]: {
        textTransform: "lowercase",
      },
    },
  },
}));
